import { lazy } from 'react';

export const PlayerAmlRiskLevelForm = lazy(
  () => import('./PlayerAmlRiskLevelForm'),
);
